"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-nan"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _debounce = _interopRequireDefault(require("./debounce"));
var _useResizeObserver = _interopRequireDefault(require("./useResizeObserver"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var useAutoOverflow = function useAutoOverflow() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    disable = _ref.disable,
    targetRef = _ref.targetRef,
    children = _ref.children,
    overflowElement = _ref.overflowElement,
    _ref$overflowPadding = _ref.overflowPadding,
    overflowPadding = _ref$overflowPadding === void 0 ? 0 : _ref$overflowPadding,
    itemGap = _ref.itemGap,
    overflowFromStart = _ref.overflowFromStart,
    overflownProps = _ref.overflownProps,
    debounceDelay = _ref.debounceDelay;
  var childrenCount = _react.default.Children.count(children);
  var _useState = (0, _react.useState)(overflowFromStart ? 0 : childrenCount),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    overflowIndex = _useState2[0],
    setOverflowIndex = _useState2[1];
  var childRefs = (0, _react.useRef)([]);
  var overflowElementRef = (0, _react.useRef)();
  var isItemAllowedToOverflow = function isItemAllowedToOverflow(index) {
    var _childRefs$current$in;
    return !((_childRefs$current$in = childRefs.current[index]) !== null && _childRefs$current$in !== void 0 && _childRefs$current$in.getAttribute('data-no-overflow'));
  };
  var getTargetStyles = function getTargetStyles() {
    var _window, _window$getComputedSt;
    if (!targetRef.current) return {};
    var styles = ((_window = window) === null || _window === void 0 || (_window$getComputedSt = _window.getComputedStyle) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.call(_window, targetRef.current)) || {};
    var padding = parseInt(styles === null || styles === void 0 ? void 0 : styles['padding-left'], 10) + parseInt(styles === null || styles === void 0 ? void 0 : styles['padding-right'], 10);
    var gap = parseInt(styles === null || styles === void 0 ? void 0 : styles['column-gap'], 10);
    return {
      padding: (0, _isNan.default)(padding) ? 0 : padding,
      gap: (0, _isNan.default)(gap) ? 0 : gap
    };
  };
  var markOverflowItems = function markOverflowItems(containerWidth) {
    var targetStyles = getTargetStyles();

    // go through items not allowed to be overflown to figure out
    // a fixed amount of space
    var fixedAmountUsed = targetStyles.padding;
    var gap = itemGap || targetStyles.gap || 0;
    for (var i = 0; i < (((_childRefs$current = childRefs.current) === null || _childRefs$current === void 0 ? void 0 : _childRefs$current.length) || 0); i += 1) {
      var _childRefs$current;
      if (!isItemAllowedToOverflow(i)) {
        var item = childRefs.current[i];
        var itemWidth = ((item === null || item === void 0 ? void 0 : item.offsetWidth) || 0) + gap;
        fixedAmountUsed += itemWidth;
      }
    }
    var availableContainerWidth = containerWidth - (overflowElementRef.current ? overflowElementRef.current.offsetWidth + gap : 0) - overflowPadding - fixedAmountUsed;
    var idx;
    var amountUsed = 0;
    if (overflowFromStart) {
      for (idx = (((_childRefs$current2 = childRefs.current) === null || _childRefs$current2 === void 0 ? void 0 : _childRefs$current2.length) || 0) - 1; idx >= 0; idx -= 1) {
        var _childRefs$current2;
        if (isItemAllowedToOverflow(idx)) {
          var _item = childRefs.current[idx];
          var _itemWidth = ((_item === null || _item === void 0 ? void 0 : _item.offsetWidth) || 0) + gap;
          amountUsed += _itemWidth;
          if (amountUsed > availableContainerWidth) {
            idx += 1;
            break;
          }
        }
      }
    } else {
      // from end
      for (idx = 0; idx < (((_childRefs$current3 = childRefs.current) === null || _childRefs$current3 === void 0 ? void 0 : _childRefs$current3.length) || 0); idx += 1) {
        var _childRefs$current3;
        if (isItemAllowedToOverflow(idx)) {
          var _item2 = childRefs.current[idx];
          var _itemWidth2 = ((_item2 === null || _item2 === void 0 ? void 0 : _item2.offsetWidth) || 0) + gap;
          amountUsed += _itemWidth2;
          if (amountUsed > availableContainerWidth) {
            break;
          }
        }
      }
    }
    setOverflowIndex(idx);
  };
  var handleResize = (0, _debounce.default)(function (_ref2) {
    var width = _ref2.width;
    markOverflowItems(width);
  }, debounceDelay);
  (0, _react.useEffect)(function () {
    var _targetRef$current;
    if (disable || !targetRef.current) return;
    handleResize({
      width: (_targetRef$current = targetRef.current) === null || _targetRef$current === void 0 ? void 0 : _targetRef$current.offsetWidth
    });
  }, [children]);
  (0, _react.useEffect)(function () {
    if (childrenCount < childRefs.current.length) {
      var _context;
      childRefs.current = (0, _slice.default)(_context = childRefs.current).call(_context, 0, childrenCount);
    }
  }, [childrenCount]);
  (0, _useResizeObserver.default)({
    targetRef: targetRef,
    onResize: handleResize,
    disconnect: disable
  });
  var isItemOverflown = function isItemOverflown(index) {
    return overflowFromStart ? index < overflowIndex : index >= overflowIndex;
  };
  var getBaseChildrenToRender = function getBaseChildrenToRender() {
    var _context2;
    return (0, _map.default)(_context2 = _react.default.Children).call(_context2, children, function (child, index) {
      var _child$props, _child$props2, _child$type, _child$type2, _child$type3;
      var isOverflown = isItemAllowedToOverflow(index) && isItemOverflown(index);
      var overflownStyle = {
        position: 'absolute',
        visibility: 'hidden',
        top: -1000,
        left: -1000
      };
      var autoOverflowProps = {
        style: isOverflown ? _objectSpread(_objectSpread({}, child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.style), overflownStyle) : child === null || child === void 0 || (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.style,
        'data-is-overflown': isOverflown ? true : undefined,
        'aria-hidden': isOverflown ? true : undefined
      };
      var consumerProps = overflownProps === null || overflownProps === void 0 ? void 0 : overflownProps(child, autoOverflowProps);
      var referElement = function referElement(element) {
        childRefs.current[index] = element;
      };
      var refProps = {
        ref: (0, _reactMergeRefs.default)([child === null || child === void 0 ? void 0 : child.ref, referElement])
      };
      var hasTarget = (child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Tooltip' || (child === null || child === void 0 || (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'Overlay' || (child === null || child === void 0 || (_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName) === 'BulkActionHelperPopover';
      if (hasTarget) {
        var _child$props3, _child$props4;
        // if the current child is a component that wraps a rendered target
        // like a tooltip, or overlay, we need to refer to the target for overflow
        // calculations hence we use attach the ref to targetProps.
        refProps = {
          targetProps: _objectSpread(_objectSpread(_objectSpread({}, child === null || child === void 0 || (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.targetProps), consumerProps === null || consumerProps === void 0 ? void 0 : consumerProps.targetProps), {}, {
            ref: (0, _reactMergeRefs.default)([child === null || child === void 0 || (_child$props4 = child.props) === null || _child$props4 === void 0 || (_child$props4 = _child$props4.targetProps) === null || _child$props4 === void 0 ? void 0 : _child$props4.ref, referElement])
          })
        };
      }
      var extendedProps = _objectSpread(_objectSpread(_objectSpread({}, autoOverflowProps), consumerProps), refProps);
      return /*#__PURE__*/_react.default.cloneElement(child, extendedProps);
    });
  };
  var getChildrenToRender = function getChildrenToRender() {
    if (overflowElement) {
      var _context3;
      return (0, _concat.default)(_context3 = []).call(_context3, (0, _toConsumableArray2.default)(getBaseChildrenToRender()), [/*#__PURE__*/_react.default.cloneElement(overflowElement, {
        'aria-hidden': true,
        key: 'overflow-element-placeholder',
        ref: (0, _reactMergeRefs.default)([overflowElement === null || overflowElement === void 0 ? void 0 : overflowElement.ref, overflowElementRef]),
        style: {
          position: 'absolute',
          visibility: 'hidden',
          top: -1000,
          left: -1000
        }
      })]);
    }
    return getBaseChildrenToRender();
  };
  var overflowChildrenToRender = [];
  if (!disable) {
    _react.default.Children.forEach(children, function (child, index) {
      if (isItemAllowedToOverflow(index) && isItemOverflown(index)) {
        overflowChildrenToRender.push(child);
      }
    });
  }
  return disable ? {} : {
    overflowIndex: overflowIndex,
    handleResize: handleResize,
    isOverflowing: overflowChildrenToRender.length > 0,
    childrenToRender: getChildrenToRender(),
    overflowChildrenToRender: overflowChildrenToRender
  };
};
var _default = exports.default = useAutoOverflow;